import { faQuoteLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react';

import { Card, Col, Container, Offcanvas, Row } from 'react-bootstrap';

import team from '../../assets/img.png';
import { Header } from '../../components/Header/Header';
import { Subscribe } from '../../components/Subscribe/Subscribe';

import './PurposeScreen.scss';

export const PurposeScreen: React.FC = () => {

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const quotes = [
    {
      review: 'Since we started using this employee experience platform, I feel more connected to my team and the company as a whole. It\'s made a real difference in my day-to-day work life. I love how easy it is to use this tool to give feedback to my colleagues, manager, and leadership. I feel like my voice is really heard and valued.',
      userName: 'Anny Hall, Senior Business Analyst',
    },
    {
      review: 'This employee experience platform has been a game-changer for our organization. It\'s helped us to build a more engaged, productive, and connected workforce, and has given us valuable insights into what our employees need and want. I highly recommend it to any company looking to improve their employee experience.',
      userName: 'Miranda Stephens, VP of People & Culture',
    },
    {
      review: 'I was really impressed with how seriously our leadership team took the feedback we gave them through the employee experience platform. Not only did they listen to our concerns, but they took action to address them, which made me feel heard and valued. It\'s great to know that our opinions matter and that we\'re all working together to create a better workplace for everyone.',
      userName: 'Henry Richards, Director of Strategy & Operations',
    },
  ];

  return (
    <section>
      <Header/>
      <section>
        <Container className={ 'purpose-container' }>
          <Row className={ 'top-container align-items-center purpose-fade-in' }>
            <Col sm={ 12 } className={ 'text-center' }>
              <h1>
                We built Intramark<span className={ 'font-primary' }>^</span> to drive mutually beneficial outcomes
                for employees and organizations
              </h1>
              <h6 className={ 'mt-4' }>
                Employee experience determines workplace productivity.
                Workplace productivity determines success of organizations.
                <br/>
                Our Suite<span className={ 'font-primary' }>^</span> ensures that good, even tough, employee experience
                questions are being asked at scale, and dedicated resources are available for timely, holistic action.
                <br/>
                The outcome is mutual benefit for employees and organizations.
              </h6>
            </Col>
          </Row>
        </Container>
      </section>
      <section className={ 'bg-light d-none' }>
        <Container className={ 'purpose-container' }>
          <Row className={ 'text-start purpose-fade-in' }>
            <Col sm={ 12 }>
              <h2
                id={ 'leadership-heading' }
              >
                Leadership
              </h2>
            </Col>
          </Row>
          <Row xs={ 1 } md={ 3 } className={ 'g-4 mt-4 purpose-fade-in' }>
            { Array.from({length: 6}).map((_, idx) => (
              <Col className={ 'leadership' } key={ idx }>
                <Card onClick={ handleShow }>
                  <Card.Img variant="top" src={ team }/>
                  <Card.Body>
                    <div className={ 'text-start' }>
                      <h5>Kartik Gevariya</h5>
                      <span>Head of Technology</span>
                      <div className={ 'mt-4' }>
                        <a>View Bio</a>
                      </div>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            )) }
          </Row>
        </Container>
      </section>
      <section className={ 'bg-light purpose-fade-in' }>
        <Container className={ 'purpose-container pb-5' }>
          <Row className={ 'text-start' }>
            <Col sm={ 12 }>
              <h2
                id={ 'company-heading' }
              >
                Employees and organizations trust our partnership
              </h2>
            </Col>
          </Row>
          <Row className={ 'mt-4' }>
            <Col sm={ 12 } className={ 'text-start' }>
              Organizations benefit from a more motivated and engaged workforce, leading to increased performance and
              productivity, and a competitive advantage in the market. Employees benefit from the recognition of their
              efforts, with increased job satisfaction and engagement, leading to a more meaningful and happier work
              life.
            </Col>
            <Col sm={ 12 } className={ 'text-start mt-4' }>
              At Intramark<span className={ 'font-primary' }>^</span>,
              our Suite<span className={ 'font-primary' }>^</span>  is tailored to your
              organization's specific needs. We provide
              the tools and services to identify, measure, and improve the employee experience, leading to mutually
              beneficial outcomes for organizations and employees alike. Our Suite<span
              className={ 'font-primary' }>^</span> is designed to help you create a
              workplace culture that is driven by employee feedback and insights. We strive to ensure that organizations
              are able to provide meaningful work to their employees, and that employees are given the opportunity to
              develop their skills and grow in their career. By helping organizations and employees work together, we
              are creating a workplace experience that will lead to increased performance, productivity, and ultimately,
              a stronger business for everyone.
            </Col>
          </Row>
          <Row xs={ 1 } md={ 3 } className={ 'g-4 mt-4 d-none' }>
            { quotes.map((quote, index) => (
              <Col className={ 'quotes' } key={ index }>
                <Card border={ 'light h-100' }>
                  <Card.Body>
                    <Row>
                      <Col className={ 'text-start d-flex' }>
                        <FontAwesomeIcon icon={ faQuoteLeft } className={ 'me-2' }/>
                        <h5>{ quote.review }</h5>
                      </Col>
                    </Row>
                  </Card.Body>
                  <Card.Footer className={ 'bg-white border-0' }>
                    <Row>
                      <Col className={ 'text-end text-muted' }>
                        <i>- { quote.userName }</i>
                      </Col>
                    </Row>
                  </Card.Footer>
                </Card>
              </Col>
            )) }
          </Row>
          {/*<Row xs={3} className={"g-4 mt-4 justify-content-center align-items-center"}>
           {logos.map((logo, index) => (
           <Col sm={2} className={'ms-4 me-3'} key={index}>
           <img src={logo} width={'100%'} alt={'CompanyLogo'} loading={'eager'} />
           </Col>
           ))}
           </Row>*/ }
        </Container>
      </section>
      <section>
        <Subscribe/>
      </section>
      <Offcanvas show={ show } onHide={ handleClose }>
        <Offcanvas.Header
          closeButton
          style={ {
            backgroundImage: `url("https://intramark.io/static/media/img.1c611cd1e485162a7aae.png")`,
            height: '260px',
            backgroundSize: 'contain',
          } }
        />
        <Offcanvas.Body>
          Some text as placeholder. In real life you can have the elements you
          have chosen. Like, text, images, lists, etc.
        </Offcanvas.Body>
      </Offcanvas>
    </section>
  )
}